export const activeVariants = (product) =>
  (product?.variants || []).filter((variant) => variant && variant.isActive !== false);

export const cheapestVariant = (product) =>
  activeVariants(product).reduce((best, variant) => {
    if (!best || Number(variant.price) < Number(best.price)) return variant;
    return best;
  }, null);

export const catalogPrice = (product) => {
  const variant = cheapestVariant(product);
  const variants = activeVariants(product);
  if (!variant) {
    const selling = Number(product?.sellingPrice);
    const price = Number(product?.price || 0);
    const unit = Number.isFinite(selling) && selling > 0 ? selling : price;
    return {
      price: unit,
      compareAt: price > unit ? price : 0,
      from: false,
      stock: Number(product?.stock || 0),
    };
  }
  const price = Number(variant.price || 0);
  const compare = Number(variant.compareAtPrice || 0);
  const productMrp = Number(product?.price || 0);
  return {
    price,
    compareAt: compare > price ? compare : productMrp > price ? productMrp : 0,
    from: new Set(variants.map((item) => Number(item.price))).size > 1,
    stock: variants.reduce((total, item) => total + Number(item.stock || 0), 0),
  };
};

export const variantOffer = (variant, product) => {
  const price = Number(variant?.price ?? product?.sellingPrice ?? product?.price ?? 0);
  const compare = Number(variant?.compareAtPrice || 0);
  const productMrp = Number(product?.price || 0);
  const compareAt = compare > price ? compare : !variant && productMrp > price ? productMrp : 0;
  return { price, compareAt };
};
